import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";
import FounderVideoIntro from "@/components/founders/FounderVideoIntro";
import FoundersPhotoBook from "@/components/about/FoundersPhotoBook";
import AboutStoryTimeline from "@/components/about/AboutStoryTimeline";

const VALID_FOUNDERS = new Set(["phil", "adaeze", "kwame", "marie"]);
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export default function About() {
  const { t } = useTranslation();
  const [ogImage, setOgImage] = useState(`${BACKEND}/api/og/founder/phil`);

  useEffect(() => {
    try {
      const p = new URLSearchParams(window.location.search);
      const f = (p.get("founder") || "").toLowerCase();
      if (VALID_FOUNDERS.has(f)) {
        setOgImage(`${BACKEND}/api/og/founder/${f}`);
      }
    } catch (_) { /* ignore */ }
  }, []);

  return (
    <main data-testid="about-page">
      <SEO
        slug="about"
        title={t("about.seoTitle")}
        description={t("about.seoDescription")}
        image={ogImage}
      />
      <PageHero
        eyebrow={t("about.hero.eyebrow")}
        title={t("about.hero.title")}
        italic={t("about.hero.italic")}
        body={t("about.hero.body")}
        testId="about-hero"
      />

      <FoundersPhotoBook />

      <AboutStoryTimeline />

      {/* 30-second founder note lives here too — placeholder until asset lands */}
      <FounderVideoIntro />

      {/* Signature strip */}
      <section className="pb-24 md:pb-32 bg-canvas" data-testid="about-signature">
        <div className="container-x">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl border-t border-forest/15 pt-10"
          >
            <p className="font-serif italic text-2xl md:text-3xl text-forest leading-snug">
              {t("about.manifestoNote")}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 font-mono text-xs tracking-[0.24em] uppercase text-ink/60">
              <span>Phil-Kholynes Chidi</span>
              <span className="w-1 h-1 rounded-full bg-ink/30" />
              <span>Adaeze O.</span>
              <span className="w-1 h-1 rounded-full bg-ink/30" />
              <span>Kwame A.</span>
              <span className="w-1 h-1 rounded-full bg-ink/30" />
              <span>Marie D.</span>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
